import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import ConversationReqRepository from '@/types/conversationReqRepositoryType';
import headerObject from '@/types/headerObj';

const localHost = apiUrl;
const endPoint = 'createConversation/';
const url = localHost + endPoint;

const createConversationForRepository = async (
  req: ConversationReqRepository,
  headerObj: headerObject
) => {
  let currentData;
  if (req.UserUUID === '' || req.RepositoryUUID === '') {
    currentData = {
      Name: req.Name,
      VectorDBUrl: req.VectorDBUrl,
    };
  } else {
    currentData = {
      UserUUID: req.UserUUID,
      RepositoryUUID: req.RepositoryUUID,
      Name: req.Name,
      VectorDBUrl: req.VectorDBUrl,
    };
  }

  try {
    const res = await postWithAuth(url, currentData, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST,OPTIONS',
        ...headerObj,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    return data.ConversationUUID;
  } catch (err) {
    console.error(err);
  }
};

export default createConversationForRepository;
